import {
  FieldBuilder,
  FieldDefinition,
  MenuCategories,
  MenuSubcategories,
  MENU_CATEGORY_KEY,
  MENU_NAME_SUFFIX,
  MENU_SUBCATEGORY_KEY,
} from '@zendra/shared';
import { DepartmentService, PropertyService, RegionService, StandService, ZoneService } from 'cbd-proxies';

FieldBuilder.setNamespace('Geographic');

export const FORESTRYBASE_VARIATIONS_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('standName', 'Entity.Stand')
    .gridColumnMinWidth(110)
    .build(),
  FieldBuilder.foreignKey(
    'regionId',
    'Entity.Region',
    RegionService
  )
    .display('name')
    .keyField('id')
    .gridColumnMinWidth(90)
    .build(),
  FieldBuilder
    .text('regionCode', 'Entity.ForestryBase.Variations.RegionCode')
    .build(),
  FieldBuilder.foreignKey(
    'departmentId',
    'Entity.Department',
    DepartmentService
  )
    .display('name')
    .keyField('id')
    .gridColumnMinWidth(140)
    .build(),
  FieldBuilder.foreignKey(
    'zoneId',
    'Entity.Zone',
    ZoneService
  )
    .display('name')
    .keyField('id')
    .gridColumnMinWidth(140)
    .build(),
  FieldBuilder.foreignKey(
    'propertyId',
    'Entity.Property',
    PropertyService
  )
    .display('name')
    .keyField('id')
    .gridColumnMinWidth(120)
    .build(),
  FieldBuilder
    .text('propertyCode', 'Entity.ForestryBase.Variations.PropertyCode')
    .build(),
  FieldBuilder
    .number('initialCycle', 'Entity.ForestryBase.Variations.InitialCycle')
    .gridColumnMinWidth(110)
    .filterable(false)
    .sortable(false)
    .build(),
  FieldBuilder
    .number('initialRotation', 'Entity.ForestryBase.Variations.InitialRotation')
    .gridColumnMinWidth(120)
    .filterable(false)
    .sortable(false)
    .build(),
  FieldBuilder
    .number('initialStandArea', 'Entity.ForestryBase.Variations.InitialStandArea')
    .decimal()
    .gridColumnMinWidth(140)
    .filterable(false)
    .sortable(false)
    .build(),
  FieldBuilder
    .number(
      'initialEucalyptusArea',
      'Entity.ForestryBase.Variations.InitialEucalyptusArea',
    )
    .decimal()
    .gridColumnMinWidth(170)
    .filterable(false)
    .sortable(false)
    .build(),
  FieldBuilder
    .number('initialPlantedArea', 'Entity.ForestryBase.Variations.InitialPlantedArea')
    .decimal()
    .gridColumnMinWidth(150)
    .filterable(false)
    .sortable(false)
    .build(),
  FieldBuilder
    .text(
      'initialPropertyTypeName',
      'Entity.ForestryBase.Variations.InitialPropertyTypeName',
    )
    .gridColumnMinWidth(170)
    .filterable(false)
    .sortable(false)
    .build(),
  FieldBuilder
    .text(
      'initialForestryStatus',
      'Entity.ForestryBase.Variations.InitialForestryStatus',
    )
    .gridColumnMinWidth(170)
    .filterable(false)
    .sortable(false)
    .build(),
  FieldBuilder
    .text(
      'initialForestrySituation',
      'Entity.ForestryBase.Variations.InitialForestrySituation',
    )
    .gridColumnMinWidth(180)
    .filterable(false)
    .sortable(false)
    .build(),
  FieldBuilder
    .date(
      'initialPlantationDate',
      'Entity.ForestryBase.Variations.InitialPlantationDate',
    )
    .gridColumnMinWidth(150)
    .filterable(false)
    .sortable(false)
    .build(),
  FieldBuilder
    .number('finalCycle', 'Entity.ForestryBase.Variations.FinalCycle')
    .gridColumnMinWidth(110)
    .filterable(false)
    .sortable(false)
    .build(),
  FieldBuilder
    .number('finalRotation', 'Entity.ForestryBase.Variations.FinalRotation')
    .gridColumnMinWidth(120)
    .filterable(false)
    .sortable(false)
    .build(),
  FieldBuilder
    .number('finalStandArea', 'Entity.ForestryBase.Variations.FinalStandArea')
    .decimal()
    .gridColumnMinWidth(140)
    .filterable(false)
    .sortable(false)
    .build(),
  FieldBuilder
    .number(
      'finalEucalyptusArea',
      'Entity.ForestryBase.Variations.FinalEucalyptusArea',
    )
    .decimal()
    .gridColumnMinWidth(170)
    .filterable(false)
    .sortable(false)
    .build(),
  FieldBuilder
    .number('finalPlantedArea', 'Entity.ForestryBase.Variations.FinalPlantedArea')
    .decimal()
    .gridColumnMinWidth(150)
    .filterable(false)
    .sortable(false)
    .build(),
  FieldBuilder
    .text(
      'finalPropertyTypeName',
      'Entity.ForestryBase.Variations.FinalPropertyTypeName',
    )
    .gridColumnMinWidth(170)
    .filterable(false)
    .sortable(false)
    .build(),
  FieldBuilder
    .text(
      'finalForestryStatus',
      'Entity.ForestryBase.Variations.FinalForestryStatus',
    )
    .gridColumnMinWidth(170)
    .filterable(false)
    .sortable(false)
    .build(),
  FieldBuilder
    .text(
      'finalForestrySituation',
      'Entity.ForestryBase.Variations.FinalForestrySituation',
    )
    .gridColumnMinWidth(180)
    .filterable(false)
    .sortable(false)
    .build(),
  FieldBuilder
    .date(
      'finalPlantationDate',
      'Entity.ForestryBase.Variations.FinalPlantationDate',
    )
    .gridColumnMinWidth(150)
    .filterable(false)
    .sortable(false)
    .build(),
  FieldBuilder
    .number('standAreaVariation', 'Entity.ForestryBase.Variations.StandAreaVariation')
    .decimal()
    .gridColumnMinWidth(150)
    .filterable(false)
    .sortable(false)
    .build(),
  FieldBuilder
    .number(
      'eucalyptusAreaVariation',
      'Entity.ForestryBase.Variations.EucalyptusAreaVariation',
    )
    .decimal()
    .gridColumnMinWidth(170)
    .filterable(false)
    .sortable(false)
    .build(),
  FieldBuilder
    .number(
      'plantedAreaVariation',
      'Entity.ForestryBase.Variations.PlantedAreaVariation',
    )
    .decimal()
    .gridColumnMinWidth(160)
    .filterable(false)
    .sortable(false)
    .build(),
  FieldBuilder
    .text('variationType', 'Entity.ForestryBase.Variations.VariationType')
    .gridColumnMinWidth(140)
    .filterable(false)
    .sortable(false)
    .build(),
  FieldBuilder
    .checkbox('areaChanged', 'Entity.ForestryBase.Variations.AreaChanged')
    .gridColumnMinWidth(120)
    .filterable(false)
    .sortable(false)
    .build(),
  FieldBuilder
    .checkbox(
      'propertyTypeChanged',
      'Entity.ForestryBase.Variations.PropertyTypeChanged',
    )
    .gridColumnMinWidth(160)
    .filterable(false)
    .sortable(false)
    .build(),
  FieldBuilder
    .checkbox(
      'forestStatusEnvironmentChanged',
      'Entity.ForestryBase.Variations.ForestStatusEnvironmentChanged',
    )
    .gridColumnMinWidth(210)
    .filterable(false)
    .sortable(false)
    .build(),
  FieldBuilder
    .checkbox('plantingDateChanged', 'Entity.ForestryBase.Variations.PlantingDateChanged')
    .gridColumnMinWidth(160)
    .filterable(false)
    .sortable(false)
    .build(),
];

export const FORESTRYBASE_VARIATIONS_COLUMN_GROUPS = [
  {
    labelKey: 'Geographic::Entity.ForestryBase.Variations.ColumnGroup.Context',
    fieldKeys: [
      'standName',
      'regionId',
      'regionCode',
      'departmentId',
      'zoneId',
      'propertyId',
      'propertyCode'
    ],
  },
  {
    labelKey: 'Geographic::Entity.ForestryBase.Variations.ColumnGroup.Initial',
    fieldKeys: [
      'initialCycle',
      'initialRotation',
      'initialStandArea',
      'initialEucalyptusArea',
      'initialPlantedArea',
      'initialPropertyTypeName',
      'initialForestryStatus',
      'initialForestrySituation',
      'initialPlantationDate',
    ],
  },
  {
    labelKey: 'Geographic::Entity.ForestryBase.Variations.ColumnGroup.Final',
    fieldKeys: [
      'finalCycle',
      'finalRotation',
      'finalStandArea',
      'finalEucalyptusArea',
      'finalPlantedArea',
      'finalPropertyTypeName',
      'finalForestryStatus',
      'finalForestrySituation',
      'finalPlantationDate',
    ],
  },
  {
    labelKey: 'Geographic::Entity.ForestryBase.Variations.ColumnGroup.Variation',
    fieldKeys: [
      'standAreaVariation',
      'eucalyptusAreaVariation',
      'plantedAreaVariation',
      'variationType',
    ],
  },
  {
    labelKey: 'Geographic::Entity.ForestryBase.Variations.ColumnGroup.VariationTypeDetail',
    fieldKeys: [
      'areaChanged',
      'propertyTypeChanged',
      'forestStatusEnvironmentChanged',
      'plantingDateChanged',
    ],
  },
] as const;

export const FORESTRYBASE_VARIATIONS_TABLE_OPTIONS = {
  enableFiltering: true,
  enableGridMenu: true,
  enableColumnPicker: false,
  enableColumnReorder: false,
  enableHeaderMenu: true,
  headerMenu: {
    hideColumnHideCommand: true,
  },
  createPreHeaderPanel: true,
  showPreHeaderPanel: true,
  preHeaderPanelHeight: 34,
} as const;

export const FORESTRYBASE_VARIATIONS_CONFIG = {
  entityName: 'ForestryBaseVariations',
  localizationKey: 'Geographic::Entity.ForestryBase.Variations',
  fields: FORESTRYBASE_VARIATIONS_FIELDS,
  permission: 'PlanningGeography.ForestryBases',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.QueriesPlanning + MENU_NAME_SUFFIX,
};
